import {
  SET_START,
  SET_CURRENT_COORDS,
  SET_DRAGGING,
} from './actions';

const setStart = (state, { id, startCoords, startTimestamp }) => ({
  ...state,
  [id]: {
    ...state[id],
    startCoords,
    currentCoords: startCoords,
    startTimestamp,
    isDragging: false,
    didSwipe: false,
  },
});

const setCurrentCoords = (state, { id, currentCoords }) => ({
  ...state,
  [id]: {
    ...state[id],
    currentCoords,
  },
});

const setDragging = (state, { id }) => ({
  ...state,
  [id]: {
    ...state[id],
    isDragging: true,
  },
});

const reducer = {
  [SET_START]: setStart,
  [SET_CURRENT_COORDS]: setCurrentCoords,
  [SET_DRAGGING]: setDragging,
};

export default (state = {}, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
